var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pane-content"},[(_vm.title || _vm.$slots.title)?_c('div',{staticClass:"pane-title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n    "),_vm._t("title")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }